import { pxToRemUnit } from './px-to-rem.js'

export default {
    init(Alpine) {
        Alpine.data('heroWrapper', () => {
            let resizeObserver = null
            let mutationObserver = null

            return {
                init() {
                    resizeObserver = new ResizeObserver(() => this.setMinHeight())
                    mutationObserver = new MutationObserver(() => {
                        this.observeSizeChanges()
                        this.setMinHeight()
                    })

                    this.observeSizeChanges()
                    mutationObserver.observe(this.$el, {
                        childList: true,
                        subtree: true,
                    })
                    this.setMinHeight()
                },

                observeSizeChanges() {
                    resizeObserver.disconnect()

                    this.$el.querySelectorAll('.hero-content, .hero-asset').forEach((element) => {
                        resizeObserver.observe(element)
                    })
                },

                setMinHeight() {
                    const elements = this.$el.querySelectorAll('.hero-content, .hero-asset')
                    const maxHeight = Math.max(0, ...Array.from(elements, (element) => element.offsetHeight))
                    const minHeight = maxHeight > 0 ? pxToRemUnit(maxHeight) : ''

                    if (this.$el.style.minHeight !== minHeight) {
                        this.$el.style.minHeight = minHeight
                    }
                },

                destroy() {
                    resizeObserver?.disconnect()
                    mutationObserver?.disconnect()
                },
            }
        })
    },
}
